import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="bg-white text-[#050B14]">
      <Navigation />
      <main>
        <section className="bg-[#F4F8FC] pt-40 md:pt-48 pb-16 md:pb-24 border-b border-[#E5EBF2]">
          <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
            <div className="italic-display font-normal text-[#0E2A57] text-[10rem] md:text-[14rem] leading-none">
              404
            </div>
            <h1 className="mt-2 font-heading font-extrabold text-3xl md:text-5xl tracking-[-0.035em] text-[#0E2A57]">
              This page hasn't been{" "}
              <span className="italic-display font-normal text-[#2BB6E5]">
                cleaned up yet.
              </span>
            </h1>
            <p className="mt-6 text-[#475569] text-lg max-w-xl mx-auto leading-relaxed">
              The page you were looking for doesn't exist or has moved. Try
              heading back to the home page or speak to a member of the AGS
              family.
            </p>

            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <Link
                to="/"
                data-testid="notfound-home"
                className="group inline-flex items-center gap-3 bg-[#0E2A57] text-white hover:bg-[#081A37] px-7 py-3.5 font-semibold tracking-wide transition-colors"
              >
                <Home size={16} />
                Back to home
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-3 border-2 border-[#0E2A57] text-[#0E2A57] hover:bg-[#0E2A57] hover:text-white px-7 py-3.5 font-semibold tracking-wide transition-all"
              >
                <ArrowLeft size={16} />
                Talk to us
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
